export const POPULAR_FONTS = [
	'Inter',
	'Outfit',
	'Montserrat',
	'Playfair Display',
	'Lora',
	'Roboto',
	'Poppins',
	'Oswald',
	'Merriweather',
	'Raleway',
	'Bebas Neue',
	'Cinzel',
	'Pacifico',
	'Fira Sans',
	'Caveat',
	'Dancing Script',
	'Great Vibes',
	'Sacramento',
	'Lobster',
	'Comfortaa',
	'Abril Fatface',
	'Quicksand',
	'Nunito',
	'Kanit',
	'Rubik'
];

export function getFontFamilyName(family: string): string {
	switch (family) {
		case 'poppins':
			return 'Poppins';
		case 'robotoc':
			return 'Roboto Condensed';
		case 'merriweather':
			return 'Merriweather';
		default:
			return family;
	}
}

export function getFontUrls(family: string) {
	if (family === 'default' || !family) {
		return null;
	}

	// Static predefined fonts with optimized full ranges
	if (family === 'poppins') {
		return [
			'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100..900;1,100..900&display=swap'
		];
	}
	if (family === 'robotoc') {
		return [
			'https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&display=swap'
		];
	}
	if (family === 'merriweather') {
		return [
			'https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,100..900;1,100..900&display=swap',
			'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap'
		];
	}

	// Arbitrary custom Google Fonts (safe request to avoid 400 Bad Request on fonts that don't support 100-900 weights or italic axis)
	const resolvedFamily = getFontFamilyName(family);
	const formattedFamily = resolvedFamily.split(' ').join('+');
	return [`https://fonts.googleapis.com/css2?family=${formattedFamily}&display=swap`];
}

const loadedFontsCache = new Set<string>();

export async function loadGoogleFont(fontName: string): Promise<boolean> {
	if (fontName === 'default' || !fontName) {
		return true;
	}
	const resolvedName = getFontFamilyName(fontName);
	if (loadedFontsCache.has(resolvedName)) {
		return true;
	}

	const urls = getFontUrls(fontName);
	if (!urls || urls.length === 0) {
		return true;
	}

	if (typeof document !== 'undefined') {
		urls.forEach((url, index) => {
			const fontId = `gfont-${resolvedName.toLowerCase().replace(/\s+/g, '-')}-${index}`;
			if (!document.getElementById(fontId)) {
				const link = document.createElement('link');
				link.id = fontId;
				link.rel = 'stylesheet';
				link.href = url;
				document.head.appendChild(link);
			}
		});

		try {
			await Promise.all([
				document.fonts.load(`1em "${resolvedName}"`),
				document.fonts.load(`bold 1em "${resolvedName}"`)
			]);
			loadedFontsCache.add(resolvedName);
			return true;
		} catch (error) {
			console.error(`Error loading font "${resolvedName}":`, error);
			return false;
		}
	}
	return false;
}
